import React from "react";
import styled from "styled-components";
import Filters from "./Filters";

const DesktopFiltersWrapper: React.FC = props => {
  return (
    <Wrapper>
      {/* <Text className="label">Show / Hide:</Text> */}
      <Filters />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-right: 2rem;

  @media (max-width: 960px) {
    display: none;
  }
`;

export default DesktopFiltersWrapper;
